import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {ReactiveFormsModule} from '@angular/forms';
import { HighchartsChartModule } from 'highcharts-angular';

import {
  MatCardModule,
  MatStepperModule,
  MatFormFieldModule,
  MatInputModule,
  MatButtonModule,
  MatIconModule,
  MatRadioModule,
  MatDividerModule,
  MatExpansionModule,
  MatTabsModule,
  MatButtonToggleModule,
  MatOptionModule,
  MatSelectModule,
  MatTooltipModule,
} from '@angular/material';

import { AppComponent } from './app.component';
import { ClientQuestionnaireComponent } from './client-questionnaire/client-questionnaire.component';


@NgModule({
  declarations: [
    AppComponent,
    ClientQuestionnaireComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    MatCardModule,
    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatRadioModule,
    MatDividerModule,
    MatExpansionModule,
    MatTabsModule,
    MatButtonToggleModule,
    MatOptionModule,
    MatSelectModule,
    MatTooltipModule,
    HighchartsChartModule

  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
